import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Instagram, Facebook, Youtube, Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  const socials = [
    {icon:Instagram,href:'https://instagram.com/gsagency',label:'Instagram'},
    {icon:Facebook,href:'https://facebook.com/gsagency',label:'Facebook'},
    {icon:Youtube,href:'https://youtube.com/gsagency',label:'YouTube'}
  ];

  return (
    <footer className="bg-[#020202] border-t border-white/8">
      <div className="container-premium py-16 md:py-24">
        <div className="grid md:grid-cols-2 lg:grid-cols-[1.2fr_1fr_1fr_1fr] gap-12">
          <div>
            <Link to="/" className="inline-block mb-7">
              <img src="/brand-assets/gs-agency-logo-silver.png" alt="GS Agency Art & Technology" className="h-24 w-auto"/>
            </Link>
            <p className="text-white/42 text-sm leading-relaxed max-w-sm mb-7">
              Tecnología para crear, impulsar y monetizar marcas. Arte y tecnología en vanguardia.
            </p>
            <div className="flex gap-3">
              {socials.map(s=><a key={s.label} href={s.href} target="_blank" rel="noreferrer" aria-label={s.label} className="w-10 h-10 border border-white/10 flex items-center justify-center text-white/45 hover:text-white hover:border-white/30"><s.icon size={17}/></a>)}
            </div>
          </div>

          <div>
            <h4 className="footer-title">Technology</h4>
            <ul className="footer-list">
              <li><Link to="/technology">Build</Link></li>
              <li><Link to="/technology">Automate</Link></li>
              <li><Link to="/technology">Grow</Link></li>
              <li><Link to="/technology">Monetize</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="footer-title">Creative Art</h4>
            <ul className="footer-list">
              <li><Link to="/creative-art">Brand & Identity</Link></li>
              <li><Link to="/creative-art">Content & Media</Link></li>
              <li><Link to="/eventos">Events & Experiences</Link></li>
              <li><Link to="/talent">Talent</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="footer-title">Contacto</h4>
            <ul className="space-y-4 text-white/45 text-sm">
              <li className="flex gap-3"><Mail size={17} className="text-[#d7dbe0] shrink-0"/><a href="mailto:info@gsagency.com" className="hover:text-white">{t('contact.info.email')}</a></li>
              <li className="flex gap-3"><Phone size={17} className="text-[#d7dbe0] shrink-0"/><a href="tel:+5255187377664" className="hover:text-white">+52 55 1873 7664</a></li>
              <li className="flex gap-3"><MapPin size={17} className="text-[#d7dbe0] shrink-0"/><span>{t('contact.info.location')}</span></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/7">
        <div className="container-premium py-6 flex flex-col md:flex-row gap-4 items-center justify-between">
          <p className="text-white/30 text-xs">© {year} GS AGENCY Art & Technology. {t('footer.rights')}.</p>
          <div className="flex gap-6 text-xs text-white/30">
            <Link to="/privacy" className="hover:text-white/60">{t('footer.privacy')}</Link>
            <Link to="/terms" className="hover:text-white/60">{t('footer.terms')}</Link>
            <Link to="/cookies" className="hover:text-white/60">{t('footer.cookies')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
